import { useSelector } from "react-redux";

import { ComponentBadgesDetail } from "@components";
import { selectAuth } from "@redux";


export const PageBadgesDetail = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentBadgesDetail
            memberTier={memberTier} avatar={""} fullName={""} socials={[]} />
    );
};
